import { IconComponent } from 'models/icons';

/**
 * @deprecated This component has following errors from generation:
 *
 * **ERROR: assets/icons/new-folder.svg contains multiple fill colors. Please adjust it so that it has only one fill color.**
 *
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/new-folder.svg
 */
const IconNewFolder: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M21.342 6.243A2.143 2.143 0 0123.5 8.4v10.069a2.145 2.145 0 01-2.158 2.156H2.655A2.144 2.144 0 01.5 18.47V5.53a2.14 2.14 0 012.155-2.155h7.188L12.72 6.25l8.623-.008zm-.27 12.213a.319.319 0 00.27-.27V8.663a.317.317 0 00-.27-.27H11.82L8.946 5.517h-6.02a.317.317 0 00-.27.27v12.4a.317.317 0 00.269.27h18.147z"
      fill="currentColor"
    />
    <path
      d="M15.892 11.336h7.07v8.448h-8.448v-7.07a1.377 1.377 0 011.378-1.378z"
      fill="currentColor"
    />
    <path
      d="M22.287 15.801a.362.362 0 01-.36.361h-2.185v2.186a.36.36 0 01-.36.358h-.214a.36.36 0 01-.358-.358v-2.186h-2.185a.36.36 0 01-.36-.36v-.214a.36.36 0 01.105-.254.358.358 0 01.255-.104h2.185v-2.188a.358.358 0 01.358-.357h.214a.358.358 0 01.36.357v2.188h2.185a.358.358 0 01.36.358v.213z"
      fill="currentColor"
    />
  </svg>
);

export default IconNewFolder;
